// extracted by mini-css-extract-plugin
module.exports = {"bottomLine":"Manage_bottomLine__2F7Ke","main":"Manage_main__1YjMF","img":"Manage_img__3AjS4"};